"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCapital = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M59.48 55.53h-2.9v-13.7h2.9a1.6 1.6 0 0 0 0-3.2h-3a21.58 21.58 0 0 0-19.88-19.9v-2.16H46a1.6 1.6 0 0 0 1.6-1.6V9.31a1.6 1.6 0 0 0-1.6-1.6h-9.4v-.84a1.6 1.6 0 1 0-3.2 0v11.86a21.58 21.58 0 0 0-19.9 19.9h-3a1.6 1.6 0 0 0 0 3.2h2.9v13.7h-2.9a1.6 1.6 0 0 0 0 3.2h49a1.6 1.6 0 0 0 0-3.2zm-16.22 0v-13.7h3.46v13.7zm-9.86-13.7v13.7h-3.46v-13.7zm3.2 0h3.46v13.7H36.6zm-9.86 0v13.7h-3.46v-13.7zm26.64 13.7h-3.46v-13.7h3.46zM35 21.85a18.4 18.4 0 0 1 18.31 16.77H16.69A18.4 18.4 0 0 1 35 21.85zm9.36-10.95v2.46H36.6v-2.45zM16.62 41.83h3.46v13.7h-3.46z"
  })),
  height: undefined,
  width: undefined
});
IconCapital.displayName = 'IconCapital';
var _default = IconCapital;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/capital.js
// module id = 550
// module chunks = 0